import React, { ChangeEvent, Component } from 'react';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable, changeApiVariableAuth } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaLabel from '../../../../custom/FormicaLabel';
import ComponentName from '../../../../../constant/ComponentName';

class BearerAuthComponent extends Component<Props, State> {
  public state = new State();

  render() {
    const { bearerToken } = this.state;
    const { disabled } = this.props;
    return (
      <div className={'w-full h-full flex flex-col'}>
        <div className={'flex flex-col w-full gap-y-2'}>
          <FormicaLabel label={'Token'} />
          <FormicaInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeToken(e)}
            disabled={disabled}
            value={'Bearer ' + bearerToken}
            label={'Token'}
            data-testid={`${ComponentName.API_VARIABLE}_bearer_auth_token_input`}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const {
      apiVariable: { apiVariable },
    } = this.props;
    const token = apiVariable.headers['Authorization']?.split('Bearer');
    if (token && token.length > 1) {
      this.setState({ bearerToken: token[1].trim() });
    }
  }

  private onChangeToken(e: ChangeEvent<HTMLInputElement>) {
    const {
      changeApiVariable,
      apiVariable: { apiVariable },
    } = this.props;
    let token = e.target.value;
    if (token.startsWith('Bearer ')) {
      token = e.target.value.replace('Bearer ', '');
    } else token = '';
    apiVariable.headers['Authorization'] = 'Bearer ' + token;
    this.setState({ bearerToken: token });
    changeApiVariable(apiVariable);
  }
}

interface Props extends ReduxProps {
  disabled?: boolean;
}

class State {
  bearerToken: string = '';
}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  isUpdate: state.apiVariable.isUpdate,
  auth: state.apiVariable.auth,
});

const mapDispatchToProps = { changeApiVariable, changeApiVariableAuth };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(BearerAuthComponent);
